/* Source: src/mt-includes/widgets/actions/src/frontend/init.frontend.js*/
angular.module('website.widget.actions', [
    'website.widget.actions.open_popup',
    'website.widget.actions.scroll_to'
]);
